(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digit-posts"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function() {
      var displayPosts = 8; // ブログ記事の表示数（最大10）
      fetch('https://voyger.info/preppy/', {cache: "no-store"})
      .then(response => response.json())
      .then(function(data) {
          var posts = [];
          for (var index = 0; index < displayPosts; index++) {
              var value = data[index];
              var date  = value.date ? value.date: null;
              if ( date ) {
                  var postDate = new Date(Date.parse(date));
                  var year = postDate.getFullYear();
                  var month = String(postDate.getMonth() + 1).padStart(2, '0');
                  var day = String(postDate.getDate()).padStart(2, '0');
                  date = `${year}.${month}.${day}`;
              }
              var post  = {
                  title   : value.title && value.title.rendered ? value.title.rendered : null,
                  link    : value.link ? value.link: null,
                  date    : date,
                  img     : value.yoast_head_json.og_image[0].url ? value.yoast_head_json.og_image[0].url: null,
                  excerpt : value.excerpt && value.excerpt.rendered ? value.excerpt.rendered : null
              };
              posts.push(post);
          }
          var source   = document.getElementById('digit-blog-posts-template').innerHTML;
          var compiled = _.template(source);
          var target   = document.getElementById('shopify-section-template--dig-it');
          target.innerHTML = compiled({posts}); // ブログ記事を出力
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const sectionEl = document.querySelector('.product-recommendations');

  function loadProductRecommendations() {
    const { limit, url } = sectionEl.dataset;

    fetch(sectionEl.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const div = document.createElement('div');
        div.innerHTML = responseText;

        const rec = div.querySelector('.product-recommendations');
        if (rec && rec.innerHTML.trim().length) {
          document.querySelector('.product-recommendations').innerHTML = rec.innerHTML;
        }

        theme.initProductTitleAlignmentWatcher(sectionEl, '.productRecommendations');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (sectionEl.dataset.sectionId === e.detail.sectionId) {
      loadProductRecommendations();
    }
  });

  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
